import React from 'react';
import useIsPermitted from 'App/utils/hooks/useIsPermitted';
import { PERMISSION_TYPES } from 'App/utils/isPermitted/isPermitted';
import { setWorkQueueFilterGenerator } from '../../workQueue.utils';
import { useFormikContext } from 'formik';
import { CheckboxField } from 'Shared/form/CheckboxField';
import AccordionWrapper from 'App/components/AccordionWrapper/AccordionWrapper';
import HeaderContent from '../HeaderContent';

const PredictiveModelToggleFilter = () => {
    const patientPredictiveModelEnabled = useIsPermitted(PERMISSION_TYPES.PATIENT_PREDICTIVE_MODEL);
    const {
        values: { filterParams },
        setFieldValue,
    } = useFormikContext();
    const setWorkQueueFilter = setWorkQueueFilterGenerator(setFieldValue);

    return (
        patientPredictiveModelEnabled && (
            <AccordionWrapper
                title="Predictive Model Filter"
                stateKey="workQueuePredictiveModelFilter-toggle"
                HeaderContent={HeaderContent}
                headerClassName="accordion-header-h4-title"
            >
                <CheckboxField
                    id="predictiveModelRisk"
                    fieldName="filterParams.predictiveModelRisk"
                    label="Predictive Model Patient"
                    onChange={(e) => setWorkQueueFilter(filterParams, 'predictiveModelRisk', e.target.checked, true)}
                />
            </AccordionWrapper>
        )
    );
};

export default PredictiveModelToggleFilter;
